import React from 'react'

const OnpageInlineEditor = React.createClass({

  getInitialState: function () {
    return {
      text:    this.props.text,
      editing: false,
      saving: false,
      applyToAll: false
    }
  },

  handleOnClick(event) {
    this.setState({ editing: true })
  },

  onChangeHandler(event) {
    this.setState({ text: event.target.value })
  },

  onCheckBoxChangeHandler(event) {
    this.setState({ applyToAll: event.target.checked })
  },

  saveEditedText() {
    let dataParams = {}
    dataParams[this.props.columnName] = this.state.text
    dataParams['apply_to_all'] = this.state.applyToAll === true ? this.state.applyToAll  : null

    if ( this.props.targetId != null && this.props.targetType != null ) {
      dataParams['target_id'] = this.props.targetId
      dataParams['target_type'] = this.props.targetType
      dataParams['suburb_id'] = this.props.suburbId
    }

    $.ajax({
      beforeSend: () => {
        this.setState({ saving: true })
      },
      url: this.props.url,
      data: dataParams,
      method: this.props.request_method || "POST"
    }).done((response) => {
      this.setState({ editing: false })
      this.setState({ saving: false })
    })
  },

  cancelEditing() {
    this.setState({ editing: false })
    this.setState({ text: this.props.text })
    this.setState({ saving: false })
  },

  renderNormal() {
    return (
      <div>
        <a href="#" className={this.props.fontStyle} onClick={this.handleOnClick}>
          { this.state.text || `Click here to add ${this.props.columnName}` }
        </a>
      </div>
    )
  },

  renderEditableText() {
    return (
      <div>
        <div>
          <textarea
            className={`${this.props.fontStyle} font-16 sm-font-16 text-copy-2`}
            style={{width: '100%'}}
            value={this.state.text}
            onChange={this.onChangeHandler}>
          </textarea>
        </div>
        <div>
          {
            this.props.showApplyToAllCheckBox ?
              <div>
                <input
                  className='m10'
                  name='applyToAll'
                  type='checkbox'
                  checked={this.state.applyToAll}
                  onChange={this.onCheckBoxChangeHandler}
                />
                <label className='text-copy-0'>apply to all other suburbs for the same category</label>
              </div>
            :
            ''
          }
          <div>
            <button
              className="btn btn-main"
              onClick={this.saveEditedText}>{this.state.saving ? 'Saving...' : 'Save'}
            </button>
            <button
              className="btn btn-warning"
              onClick={this.cancelEditing}>Cancel
            </button>
          </div>
        </div>
      </div>
    )
  },

  render() {
    return (
      this.state.editing ?
        this.renderEditableText()
      :
      this.renderNormal()
    )
  }
})

export default OnpageInlineEditor
